module.exports = __webpack_public_path__ + "img/heart.8fdcbfc4.svg";